// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__30w0a","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__RZtNy"};